import { useForm } from "react-hook-form";
import { useCallback, useRef } from "react";
import { mapMerchantDetailsToFormValues } from "../utils/merchantFormMappers";

const defaultValues = {
  merchantName: "",
  merchantAlias: "",
  registrationNumber: "",
  nationality: "",
  address: "",
  country: null,
  city: "",
  county: "",
  taxPin: "",
  directors: "",
  shareholders: "",
  merchantType: null,
  merchantSegment: null,
  currency: null,
  registrationDate: "",
  email: "",
  phoneNumber: "",
  economicSector: null,
  gender: null,
  productTransactionCode: null,
  productOwnership: null,
  productCategory: null,
  merchantAdminFirstName: "",
  merchantAdminLastName: "",
  merchantAdminEmail: "",
  merchantAdminPhoneNumber: "",
};

const useMerchantInstitutionForm = (initialMode = "create") => {
  const modeRef = useRef(initialMode);

  const setMode = useCallback((newMode) => {
    modeRef.current = newMode;
  }, []);

  const {
    control,
    handleSubmit,
    reset,
    formState,
    clearErrors,
    getValues,
    trigger,
  } = useForm({
    defaultValues,
    mode: "onTouched",
  });

  const resetToDefaults = useCallback(() => {
    reset(defaultValues);
  }, [reset]);


  const populateFromDetails = useCallback(
    (merchantDetails) => {
      const formValues = mapMerchantDetailsToFormValues(merchantDetails);
      if (formValues) {
        reset(formValues, { keepDefaultValues: true });
        return true;
      }
      return false;
    },
    [reset],
  );

  return {
    control,
    formState,
    handleSubmit,
    reset,
    resetToDefaults,
    setMode,
    modeRef,
    populateFromDetails,
    clearErrors,
    getValues,
    trigger,
  };
};

export default useMerchantInstitutionForm;
